export default function formatExpiryInput(input) {
  return input.replace(/[/]/g, "");
}
